const DIALOG_LIST_NAMESPACE = 'jbp-partner-basic-info--locations-list-dialog'

export const TRANSLATION_KEYS = {
  dialogHeader: `${DIALOG_LIST_NAMESPACE}--header-label`,

  closeButton: `${DIALOG_LIST_NAMESPACE}--close-button`,
}
